import axiosInstance from "@/api/axios-instance";

export type ConsentPurpose = "MARKETING" | "ANALYTICS" | "ADVERTISING";

export interface UserConsentState {
  purpose: ConsentPurpose;
  /** null = never answered */
  granted: boolean | null;
  policy_version: string | null;
  source: string | null;
  given_at: string | null;
}

export interface UserConsents {
  policy_version: string;
  needs_reconsent: boolean;
  purposes: UserConsentState[];
}

// DPDP consents for one user (RH-1093). The server keeps the full history too;
// the header only needs the current state per purpose.
export async function getUserConsents(userId: string): Promise<UserConsents> {
  const response = await axiosInstance.get(`/consent/user/${userId}`);
  return response.data;
}
